<div id="moreThriftDetails" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" class="modal fade text-left">
    <div role="document" class=" modal-md modal-dialog modal-dialog-centered ">
      <div class="modal-content">
        <div class="modal-header"><strong id="exampleModalLabel" class="modal-title"> {{thriftResponse?.thriftName}} </strong>
          <button type="button" (click)="killComponent()" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
        </div>
        <div class="modal-body" style="text-transform: capitalize; font-size: 18px;">
          <p>Description: {{thriftResponse?.description}}</p>
          <!-- <p>Duration: {{thriftResponse?.duration}}</p> -->
          <p>Attainable Amount: N{{thriftResponse?.attainableAmount}}</p>
          <p>Start Date: {{thriftResponse?.startDate}} </p>
          <p>End Date: {{thriftResponse?.endDate}} </p>
          <p>Thrift Creator: {{userDetails}}</p>
          <p>Number of Participants: {{thriftResponse?.noOfPeople}} </p>
          <p>Contact: {{fullUserDetails?.phone}} </p>
       
        </div>

        <section class="no-padding-top">
          <div class="container-fluid">
            <div class="row">

              <div class="col-lg-12">                           
                <div class="block">
                  <!-- <div class="title"><strong>Inline Form</strong></div> -->
                  <div class="block-body">
                    <form  class="form-inline">
                      <div class="form-group">
                        <label >Thrift Code</label>
                        <input id="inlineFormInput thriftcode"
                       
                        name="thrift_id" 
                         type="text" 
                         value={{thriftResponse?.thriftID}}
                         readonly
                         placeholder="Paste Thrift Code" class="mr-sm-3 form-control">

                      <!-- ISA24495 -->
                      <div class="form-group">
                        <!-- <input  data-clipboard-target="#thriftcode" value="Click To Copy" class="btn btn-primary"> -->
                        <button class="btn btn-primary"  (click)="copyText()">Copy</button>
                        
                      </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              </div>
              </div>
              </section>
        <div class="modal-footer">
            <p>Date & Time Created: {{thriftResponse?.datecreated}} | {{thriftResponse?.timeCreated}} </p>
        </div>
      </div>
    </div>
  </div>